<template>
  <div>
    <header-label
      :label="$t('connector.header')"
      prepend-icon="$g_connector" />
    <v-tabs
      v-model="tab"
      class="app-tab"
      show-arrows>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab
        v-for="(item, index) in tabs"
        :key="index">
        {{ item }}
      </v-tab>
      <v-spacer />
    </v-tabs>
    <v-tabs-items
      v-model="tab"
      class="mb-5">
      <v-tab-item :key="0">
        <v-card flat>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <shopee-update-stock />
              </v-col>
              <v-col cols="12">
                <shopee-connect-order />
              </v-col>
              <v-col cols="12">
                <shopee-connect-shipping-fee />
              </v-col>
              <v-col cols="12">
                <shopee-seller-own />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="1">
        <v-card flat>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <lazada-update-stock />
              </v-col>
              <v-col cols="12">
                <lazada-connect-order />
              </v-col>
              <v-col cols="12">
                <lazada-connect-shipping-fee />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="2">
        <website-connect-form />
        <website-cloudflare-form />
      </v-tab-item>
      <v-tab-item :key="3">
        <analyze-facebook-pixel />
        <analyze-facebook-verify-domain />
        <analyze-google-analysis />
      </v-tab-item>
    </v-tabs-items>
    <v-tabs-items v-model="tab">
      <v-tab-item :key="0">
        <v-card flat>
          <v-card-text>
            <div class="d-flex align-center mb-3">
              <title-label
                :label="$t('connector.shopee.title')"
                class="mr-3" />
              <v-btn
                to="/shop-setting/warehouse"
                color="primary"
                depressed
                rounded
              >
                {{ $t("connector.shopee.btn.store") }}
              </v-btn>
            </div>
            <shopee-data-table />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="1">
        <v-card flat>
          <v-card-text>
            <div class="d-flex align-center mb-3">
              <title-label
                :label="$t('connector.lazada.title')"
                class="mr-3" />
              <v-btn
                to="/shop-setting/warehouse"
                color="primary"
                depressed
                rounded
              >
                {{ $t("connector.lazada.btn.store") }}
              </v-btn>
            </div>
            <lazada-data-table />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="2">
      </v-tab-item>
      <v-tab-item :key="3">
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ShopeeConnectOrder from '@/views/Connector/components/Shopee/ShopeeConnectOrder.vue'
import ShopeeConnectShippingFee from '@/views/Connector/components/Shopee/ShopeeConnectShippingFee.vue'
import ShopeeUpdateStock from '@/views/Connector/components/Shopee/ShopeeUpdateStock.vue'
import ShopeeDataTable from '@/views/Connector/components/Shopee/ShopeeDataTable.vue'
import LazadaConnectOrder from '@/views/Connector/components/Lazada/LazadaConnectOrder.vue'
import LazadaUpdateStock from '@/views/Connector/components/Lazada/LazadaUpdateStock.vue'
import LazadaDataTable from '@/views/Connector/components/Lazada/LazadaDataTable.vue'
import LazadaConnectShippingFee from '@/views/Connector/components/Lazada/LazadaConnectShippingFee.vue'
import WebsiteConnectForm from '@/views/Connector/components/Website/WebsiteConnectForm.vue'
import WebsiteCloudflareForm from '@/views/Connector/components/Website/WebsiteCloudflareForm.vue'
import AnalyzeFacebookPixel from '@/views/Connector/components/Analyze/AnalyzeFacebookPixel.vue'
import AnalyzeFacebookVerifyDomain from '@/views/Connector/components/Analyze/AnalyzeFacebookVerifyDomain.vue'
import AnalyzeGoogleAnalysis from '@/views/Connector/components/Analyze/AnalyzeGoogleAnalysis.vue'
import ShopeeSellerOwn from './components/Shopee/ShopeeSellerOwn.vue'

export default {
  name: 'Connector',
  components: {
    ShopeeDataTable,
    LazadaDataTable,
    ShopeeUpdateStock,
    ShopeeConnectShippingFee,
    ShopeeConnectOrder,
    LazadaConnectOrder,
    LazadaUpdateStock,
    LazadaConnectShippingFee,
    WebsiteConnectForm,
    WebsiteCloudflareForm,
    AnalyzeFacebookPixel,
    AnalyzeGoogleAnalysis,
    AnalyzeFacebookVerifyDomain,
    ShopeeSellerOwn
  },
  data () {
    return {
      tab: 0,
      tabs: [
        this.$t('connector.shopee.tab'),
        this.$t('connector.lazada.tab'),
        this.$t('connector.website.tab'),
        this.$t('connector.analyze.tab')
      ]
    }
  },
  created () {
    if (this.$route.query.tab !== undefined) {
      this.tab = this.$route.query.tab
    }
  }
}
</script>

<style>
.connector_dialog--action {
  background: #f9f9f9;
  padding: 18px;
}
</style>

<style scoped></style>
